import type { ICustomControlDiagnosticReportReadProps } from '../../interfaces/customControlDiagnosticReportReadProps';
import { translateKey } from '../../../../../translate';
import { FormParagraph } from '../../../../elements/common';
import { FormLabel } from '../../../../elements/forms/FormLabel';
import { HorizontalFormGroupRead } from '../../../../elements/forms/horizontalFormGroupRead/HorizontalFormGroupRead';
import { InputContainer } from '../../../../elements/forms/InputContainer';

export function Osasc2V1DiagnosticReportSummary(props: ICustomControlDiagnosticReportReadProps) {
    return (
        <>
            {props.diagnosticReport.customControlData.workingDiagnosis && (
                <HorizontalFormGroupRead>
                    <FormLabel>{translateKey('diagnosticReport.workingDiagnosis')}</FormLabel>
                    <InputContainer>
                        <FormParagraph>{props.diagnosticReport.customControlData.workingDiagnosis}</FormParagraph>
                    </InputContainer>
                </HorizontalFormGroupRead>
            )}

            {props.diagnosticReport.customControlData.policy && (
                <HorizontalFormGroupRead>
                    <FormLabel>{translateKey('diagnosticReport.policy')}</FormLabel>
                    <InputContainer>
                        <FormParagraph>{props.diagnosticReport.customControlData.policy}</FormParagraph>
                    </InputContainer>
                </HorizontalFormGroupRead>
            )}
        </>
    );
}
